/* global axios */
import ApiClient from './ApiClient';

class WhatsappWebhookConfigAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  getConfig(accountId, inboxId) {
    return axios.get(
      `${this.apiVersion}/accounts/${accountId}/inboxes/${inboxId}/whatsapp/webhook_configuration`
    );
  }

  updateConfig(accountId, inboxId, configData) {
    return axios.put(
      `${this.apiVersion}/accounts/${accountId}/inboxes/${inboxId}/whatsapp/webhook_configuration`,
      { webhook_configuration: configData }
    );
  }

  fetchSubscribedFields(accountId, inboxId) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/inboxes/${inboxId}/whatsapp/webhook_configuration/fetch_subscribed_fields`
    );
  }

  subscribe(accountId, inboxId, fields) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/inboxes/${inboxId}/whatsapp/webhook_configuration/subscribe`,
      { fields }
    );
  }

  unsubscribe(accountId, inboxId) {
    return axios.delete(
      `${this.apiVersion}/accounts/${accountId}/inboxes/${inboxId}/whatsapp/webhook_configuration/unsubscribe`
    );
  }

  configureComplete(accountId, inboxId) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/inboxes/${inboxId}/whatsapp/webhook_configuration/configure_complete`
    );
  }
}

export default new WhatsappWebhookConfigAPI();
